export default function prependHttp(input) {
    const url = input.trim();
    if (/^\.*\/|^(?!localhost)\w+:/.test(url)) return url;
    return url.replace(/^(?!(?:\w+:)?\/\/)/, "http://");
};
